module.exports = __webpack_public_path__ + "img/bulkiin.f25cf194.jpg";